import { LeadLog } from '@/plugins/api'
export default {
  namespaced: true,
  state: {
    items: [],
    count: 0,
  },
  actions: {
    async fetchLogs({ commit }, options) {
      const items = await LeadLog.fetch({ ...options })
      commit('changeState', { items })
    },
  },
  getters: {
    items: state => state.items,
  },
}
